import { setPatientAndInsuranceCard } from '../../actions/InsuranceCardActions';
import {
    getBookingState,
    updateBookingState,
} from '../../actions/SchedulingActions';
import { PHONE_REQUIRED } from '../../components/AppointmentRequirements/constants';
import { hasRequirement } from '../../components/AppointmentRequirements/helpers';
import { BookingStateProperties } from '../../constants';
import { paths } from '../../paths';
import { wrapWithDispatch, pushWithQuery } from '../../utils';
import { SelectPatientPageTrackingActionCreators } from './SelectPatientPageActions';

const mapDispatchToProps = (dispatch, ownProps) => ({
    getBookingState: (bookingId) => {
        dispatch(getBookingState(bookingId));
    },
    setPatientAndInsuranceCard: (patientId) =>
        dispatch(setPatientAndInsuranceCard(patientId)),
    _onPatientSelectionSuccess: (chosenPatientId, bookingState) => {
        dispatch(
            updateBookingState({
                ...bookingState,
                [BookingStateProperties.patientId]: chosenPatientId,
            })
        );

        const phoneNumberRequired = hasRequirement(
            PHONE_REQUIRED,
            bookingState[BookingStateProperties.requirements]
        );
        const referralId = bookingState[BookingStateProperties.referralId];

        if (!phoneNumberRequired) {
            dispatch(
                pushWithQuery(
                    `${paths.appointmentDetailsPath}/${ownProps.params.bookingId}`
                )
            );
        } else if (referralId === 'text') {
            dispatch(
                pushWithQuery(
                    `${paths.phoneEntryPath}/${ownProps.params.bookingId}`
                )
            );
        } else {
            dispatch(
                pushWithQuery(
                    `${paths.phoneVerificationPath}/${ownProps.params.bookingId}`
                )
            );
        }
    },
    updateBookingState: (bookingState) => {
        dispatch(updateBookingState(bookingState));
    },
    ...wrapWithDispatch(SelectPatientPageTrackingActionCreators, dispatch),
});

export default mapDispatchToProps;
